module.exports = __webpack_public_path__ + "static/media/GN.21b1eb64.svg";